export default __webpack_public_path__ + "static/documentation-8a3dd0515c38da1c998a0bacddfd4b1f.pdf";